import { render, staticRenderFns } from "./DocumentViewerIframe.vue?vue&type=template&id=231f4432&scoped=true"
import script from "./DocumentViewerIframe.vue?vue&type=script&lang=js"
export * from "./DocumentViewerIframe.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewerIframe.vue?vue&type=style&index=0&id=231f4432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f4432",
  null
  
)

export default component.exports